export default __webpack_public_path__ + "img/67b1ba1b8a7a44ebaec40b4f8a8dfeea.png";